import { useContext, useEffect } from 'react'
import { PageContext } from '@contexts/page-context'
import { gnarSpec } from '@lib/tracking/gnar'

export const usePersonalizationGnarTracking = (personalizationType: string, variation: string | undefined) => {
  const { pageId, slug } = useContext(PageContext)

  useEffect(() => {
    if (!variation) {
      return
    }
    gnarSpec.cmsPersonalizedContentComponentShow(pageId, slug, personalizationType, variation)
  }, [pageId, personalizationType, slug, variation])
}
